import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Puedes personalizar el CSS según lo que necesites
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store"; // Asegúrate de que tengas configurado tu store de Redux
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
